/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Heading_EsportsInputs */

const ja_work_heading_esports = /** @type {(inputs: Work_Heading_EsportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esports & Broadcast`)
};

const en_work_heading_esports = /** @type {(inputs: Work_Heading_EsportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esports & Broadcast`)
};

/**
* | output |
* | --- |
* | "Esports & Broadcast" |
*
* @param {Work_Heading_EsportsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const work_heading_esports = /** @type {((inputs?: Work_Heading_EsportsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Heading_EsportsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_work_heading_esports(inputs)
	return en_work_heading_esports(inputs)
});